import type { UseOffersResult } from '@updater/ui-widgets';
import {
  useTermGroupedOffers as useCoreTermGroupedOffers,
  type OfferEntry,
  type OfferPair,
  type UseTermGroupedOffersReturnType,
} from '@updater/ui-widgets';
import { useFeature } from 'services/growthbook/useFeature';

export type { OfferEntry, OfferPair, UseTermGroupedOffersReturnType };

/**
 * Returns either the raw offers or the collapsed OfferPair list depending on
 * the `provider_app_plan_length_toggle` feature flag.
 *
 * Thin wrapper: the grouping and dedupe logic lives in ui-widgets; this only
 * injects the app's GrowthBook hook and flag name.
 */
export function useTermGroupedOffers(
  rawOffers: UseOffersResult['offersWithProviders']
): UseTermGroupedOffersReturnType {
  /**
   * Growthbook Feature - https://growthbook.prod.updatron.tools/features/provider_app_plan_length_toggle
   * Jira Ticket - https://updater.atlassian.net/browse/TVI-2381
   */
  return useCoreTermGroupedOffers(rawOffers, {
    flagName: 'provider_app_plan_length_toggle',
    useFeature,
  });
}
